import { createUseStyles } from 'react-jss';
import { MiniWizardViewModel } from './MiniWizardViewModel';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CompositeQuestionProvider } from './question-provider/CompositeQuestionProvider';
import { InnerhivePage } from '../../../InnerhivePage';
import { IonButton, IonContent, IonFooter, IonPage, IonProgressBar, IonToolbar } from '@ionic/react';
import { mediaMinWidth } from '../../../theme/utils';
import { HistoryViewModel } from '../../../support/HistoryViewModel';

const useStyles = createUseStyles({
    buttonBar: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: 10,
        paddingRight: 10,

        '& > ion-button': {
            width: 120
        }
    },

    progress: {
        top: 0,
        bottom: 'unset'
    },

    page: {
        [mediaMinWidth.md]: {
            marginLeft: '30%',
            marginRight: '30%',
            maxHeight: '90%',
            marginTop: 24
        }
    },

    footer: {
        boxShadow: 'none',
        '-webkit-box-shadow': 'none'
    }
});

export const MiniWizardView: React.FC<{ miniWizard: MiniWizardViewModel; }> = ({ miniWizard: questionnaireViewModel}) => {
    const history = useInstance(HistoryViewModel);
    const questionProvider = useInstance(CompositeQuestionProvider);

    const classes = useStyles();

    const question = questionnaireViewModel.getActiveQuestion();

    const canGoBack = questionnaireViewModel.canGoBack();

    return (
        <InnerhivePage data-id="mini-questionnaire" title={questionnaireViewModel.getTitle()} skipRequireName>
            <IonPage className={classes.page}>
                <IonContent scrollY={false} data-id={question.questionId}>
                    {questionProvider.render(question, questionnaireViewModel)}
                </IonContent>
                <IonFooter className={classes.footer}>
                    <IonToolbar>
                        <IonProgressBar
                            color="success"
                            className={classes.progress}
                            value={questionnaireViewModel.getPercentComplete()}
                        ></IonProgressBar>
                        <div className={classes.buttonBar}>
                            <IonButton
                                fill="outline"
                                data-type="wizard-back"
                                onClick={canGoBack ? questionnaireViewModel.previous : () => history.back()}
                            >
                                {canGoBack ? 'Back' : 'Cancel'}
                            </IonButton>
                            <IonButton
                                data-type="wizard-next"
                                onClick={questionnaireViewModel.continue}
                                disabled={!questionnaireViewModel.isCurrentStepValid()}
                            >
                                {questionnaireViewModel.getNextLabel()}
                            </IonButton>
                        </div>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        </InnerhivePage>
    );
};
